import React, { useEffect, useState } from "react"
import { Card, Container } from "reactstrap"
import { useNavigate } from "react-router-dom"
import ConfigUrl, { axiosbaseurl } from "../../config"
import Loader from "../Loader"
import secureLocalStorage from "react-secure-storage"
import { notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import { MdAdd } from "react-icons/md"
import { Modules } from "./Modules"
import { SiTicktick } from "react-icons/si"
import { IoMdWarning } from "react-icons/io"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { FaChevronLeft, FaSave } from "react-icons/fa"

const AddRole = () => {

   document.title = "Roles | Return First Investments"

  const { checkAccess } = usePermissionData()

  const navigate = useNavigate()
  const users = secureLocalStorage.getItem("admin_credentials")

  const [allModule, setModules] = useState(Modules)

  const [roleName, setRoleName] = useState("")
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  // changeing permissions
  const updateModule = (moduleId, property) => {
    const updatedModules = allModule.map(mod => {
      if (mod.id === moduleId) {
        return { ...mod, [property]: mod[property] === 0 ? 1 : 0 }
      }
      return mod
    })
    setModules(updatedModules)
  }

  const addRolesPermissions = async e => {
    e.preventDefault()
    setError(false)

    if (roleName !== "") {
      try {
        setLoading(true)

        let permissions = allModule?.map(
          module =>
            `${module.id},${module.view},${module.add},${module.edit},${module.delete}`
        )

        const response = await axiosbaseurl.post("roles-and-permissions", {
          roleName,
          permissions: JSON.stringify(permissions),
        })

        if (response?.data?.success === true) {
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">Role Created Successfully.</div>
              </div>
            ),
            placement: "topRight",
          })
          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}roles`)
          }, 1000)
        }
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: error?.response?.data?.message,
        })
      }
    } else {
      setError(true)
    }
  }

  return (
    <>
      {loading && <Loader />}
      <React.Fragment>
        <PermittedComponent isAccess={checkAccess(5, 2)}>
          <div className="page-content">
            <Container fluid>
              {/* Render Breadcrumb */}
              <Breadcrumbs title={"Roles"} breadcrumbItem={"Add Role"} />

              <div className="card p-2 py-3">
                <div className="d-flex justify-content-between">
                  <div className="">
                    <input
                      type="text"
                      placeholder="Enter role name"
                      className="form-control"
                      value={roleName}
                      onChange={e => setRoleName(e.target.value)}
                    ></input>
                    {error && (
                      <span className="text-danger">Role name is required</span>
                    )}
                  </div>
                  <div className="text-end">
                    <button
                      className="btn edit-Button bg-success text-white me-3 rounded-5"
                      onClick={addRolesPermissions}
                    >
                      <FaSave className="me-2" />
                      Submit
                    </button>
                    <button
                      className="btn delete-Button rounded-5"
                      onClick={() => navigate(-1)}
                    >
                      <FaChevronLeft className="me-2" />
                      Back
                    </button>
                  </div>
                </div>
                <div className="Line" />

                <div className="table-responsive mt-1">
                  <table className="mb-0 table Custom-Role-Table">
                    <thead>
                      <tr>
                        <th className="text-start fw-bold text-green border-end">
                          Modules
                        </th>
                        <th className="fw-bold text-center">View</th>
                        <th className="fw-bold text-center">Add</th>
                        <th className="fw-bold text-center">Edit</th>
                        <th className="fw-bold text-center">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allModule.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="text-start border-end">
                              <input
                                id="roleId"
                                value={item.id}
                                type="hidden"
                                className="display-none bd-text-center"
                              />
                              {item.module}
                            </td>

                            <td data-column="View">
                              <div className="d-flex align-items-center justify-content-center">
                                <div className="form-check form-switch form-switch-md">
                                  <input
                                    type="checkbox"
                                    className={`form-check-input fs-2 ${item.id}`}
                                    defaultChecked={item.view === 1}
                                    onChange={() =>
                                      updateModule(item.id, "view")
                                    }
                                  />
                                </div>
                              </div>
                            </td>

                            <td data-column="Add">
                              {item.isAdd ? (
                                <div className="d-flex align-items-center justify-content-center">
                                  <div className="form-check form-switch form-switch-md">
                                    <input
                                      type="checkbox"
                                      className="form-check-input fs-2"
                                      defaultChecked={item.add === 1}
                                      onChange={() =>
                                        updateModule(item.id, "add")
                                      }
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div className="ms-0 mt-1 text-center">--</div>
                              )}
                            </td>
                            <td data-column="Edit">
                              {item.isEdit ? (
                                <div className="d-flex align-items-center justify-content-center">
                                  <div className="form-check form-switch form-switch-md">
                                    <input
                                      type="checkbox"
                                      className="form-check-input fs-2"
                                      defaultChecked={item.edit === 1}
                                      onChange={() =>
                                        updateModule(item.id, "edit")
                                      }
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div className="ms-0 mt-1 text-center">--</div>
                              )}
                            </td>

                            <td data-column="Delete">
                              {item.isDelete ? (
                                <div className="d-flex align-items-center justify-content-center">
                                  <div className="form-check form-switch form-switch-md">
                                    <input
                                      type="checkbox"
                                      className="form-check-input fs-2"
                                      defaultChecked={item.delete === 1}
                                      onChange={() =>
                                        updateModule(item.id, "delete")
                                      }
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div className="ms-0 text-center">--</div>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </Container>
          </div>
        </PermittedComponent>
      </React.Fragment>
    </>
  )
}

export default AddRole
